export const PLAYER_POSITIONS = [
  { value: "goalkeeper", label: "Torhüter" },
  { value: "defender", label: "Verteidiger" },
  { value: "midfielder", label: "Mittelfeldspieler" },
  { value: "forward", label: "Stürmer" },
];

export const translatePosition = (position?: string): string => {
  if (!position) return "Keine Position";
  const pos = PLAYER_POSITIONS.find((p) => p.value === position.toLowerCase());
  return pos ? pos.label : position;
};
